import { Injectable } from '@angular/core';

import { OrderService as ApiOrderService, OrderModel, ResponseModel } from '@core/api';
import { HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs/internal/Observable';
import { map } from 'rxjs/operators';
import * as moment from 'moment';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class OrderService {

  constructor(
    private apiOrderService: ApiOrderService
  ) {
  }

  getOrder(id: number): Observable<OrderModel> {
    return this.apiOrderService.orderIdGet(id)
      .pipe(map(res => ({ ...res.data, ...res.meta })));
  }

  getOrders(httpParams: HttpParams): Observable<ResponseModel<OrderModel[]>> {
    return this.apiOrderService.orderGet(httpParams);
  }

  getOrderHistory(httpParams: HttpParams): Observable<ResponseModel<OrderModel[]>> {
    return this.apiOrderService.orderGet(
      httpParams
        .set('status[0]', OrderModel.StatusEnum.Closed)
        .set('status[1]', OrderModel.StatusEnum.Rejected)
    );
  }

  getInrentOrders(httpParams: HttpParams): Observable<OrderModel[]> {
    return this.apiOrderService.orderGet(
      httpParams
        .set('status[0]', OrderModel.StatusEnum.InRent)
    )
      .pipe(map(res => res.data));
  }

  getActiveOrders(httpParams: HttpParams): Observable<ResponseModel<OrderModel[]>> {
    return this.apiOrderService.orderGet(
      httpParams
        .set('status[0]', OrderModel.StatusEnum.Created)
        .set('status[1]', OrderModel.StatusEnum.Verified)
        .set('status[2]', OrderModel.StatusEnum.Paid)
        .set('status[3]', OrderModel.StatusEnum.InRent)
    );
  }

  createOrder(order: OrderModel): Observable<OrderModel> {
    return this.apiOrderService.orderPost(order)
      .pipe(map(res => res.data));
  }

  inRentTrailer(id: number) {
    return this.apiOrderService.orderIdPut(
      id,
      new HttpParams()
        .set('status', OrderModel.StatusEnum.InRent)
    )
      .pipe(map(res => res.data));
  }

  rejectOrder(id: number) {
    return this.apiOrderService.orderIdPut(
      id,
      new HttpParams()
        .set('status', OrderModel.StatusEnum.Rejected)
    )
      .pipe(map(res => res.data));
  }

  downloadTransferAct(id: number): any {
    return this.apiOrderService.downloadTransferAct(id);
  }

  downloadReturnAct(id: number): any {
    return this.apiOrderService.downloadReturnAct(id);
  }

  getTimeLeft(order: OrderModel): string {
    const now = moment(new Date());
    const end = moment.utc(order.ordered_to, environment.dateFormat.server).local();

    const duration = moment.duration(end.diff(now));

    let timeLeft = '';

    const days = duration.days();
    const hours = duration.hours();
    const minutes = duration.minutes();
    if (days != 0) {
      timeLeft += Math.abs(days) + ' д ';
    }
    if (hours != 0) {
      timeLeft += Math.abs(hours) + ' ч ';
    }
    timeLeft += Math.abs(minutes) + " мин";

    return timeLeft;
  }

  isPaidTimeOver(order: OrderModel): boolean{
    const now = moment(new Date());
    const end = moment.utc(order.ordered_to, environment.dateFormat.server).local();

    return now.diff(end) >= 0;
  }
}
